

exports.__esModule = true;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$VenmoRoute', {
    path: 'venmo',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.TOKEN_PARAM_NAME]
});


_squid.$Route;

_directive.TOKEN_PARAM_NAME;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmo/route.js
// module id = ./pages/xo-venmo/route.js
// module chunks = 1